import { TabContainer } from "@scott/ui/blocks/tabs";
import type { ReactNode } from "react";
import type { TabContainerPageBlock } from "@/types/page-block";
import type { PageContext } from "@/types/page-context";
import { ContentBlocks } from "./content-blocks";

export type TabContainerBlockProps = TabContainerPageBlock & {
  pageContext: PageContext["pageContext"];
};

export function TabContainerBlock(
  props: Readonly<TabContainerBlockProps>
): ReactNode {
  const items = props.items.map((item, index) => ({
    id: item.id ?? `${props.id}-item-${index}`,
    title: item.title,
    children: (
      <ContentBlocks blocks={item.children} pageContext={props.pageContext} />
    ),
  }));

  return (
    <div data-carousel-kind="tabs" data-carousel-name={props.internalName}>
      <TabContainer
        color={props.uiConfiguration?.textColor}
        columnWidth={props.columnWidth}
        items={items}
        mode="D2C"
        paddingBottom={props.uiConfiguration?.paddingBottom}
        paddingTop={props.uiConfiguration?.paddingTop}
        showNavigationArrows={props.showNavigationArrows}
        sys={props.sys}
        title={props.title}
      />
    </div>
  );
}
